import { useState } from 'react'
import axios from "axios";
//import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
 
const AddMovie = () => {
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    //const history = useHistory();
    const history = useNavigate();
 
    const saveMovie = async (e) => {
        e.preventDefault();
        //await axios.post('http://localhost:5000/products',{
        await axios.post('http://10.100.5.11:3307/movies',{
            title: title,
            price: price
        });
        //history.push("/");
        history("/");
    }
 
    return (
        <div>
            <form onSubmit={ saveMovie }>
                <div className="field">
                    <label className="label">Title</label>
                    <input 
                        className="input"
                        type="text"
                        placeholder="Title"
                        value={ title }
                        onChange={ (e) => setTitle(e.target.value) }
                    />
                </div>
 
                <div className="field">
                    <label className="label">Price</label>
                    <input 
                        className="input"
                        type="text"
                        placeholder="Price"
                        value={ price }
                        onChange={ (e) => setPrice(e.target.value) }
                    />
                </div>
 
                <div className="field">
                    <button className="button is-primary">Save</button>
                </div>
            </form>
        </div>
    )
}
 
export default AddMovie